<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    persistent
  >
    <v-card v-if="itemVO" :loading="salvando">
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ operacao === 'editar' ? 'Editar Itens VO' : 'Adicionar Item VO' }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="ml-auto" type="submit" text :disabled="!validForm" @click="salvar(itemVO)">
          Salvar
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="formDialog" v-model="validForm" @submit.prevent>
          <v-container>
            <v-row v-if="operacao === 'adicionar'">
              <v-col>
                <v-text-field
                  v-model="itemVO.descricao"
                  label="Descrição *"
                  required
                  :rules="[obrigatorio]"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="itemVO.codigoBarra"
                  label="Código de Barras"
                  required
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-expansion-panels v-model="painelICMS">
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>
                      <v-col cols="2"> ICMS </v-col>
                      <v-col cols="10" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0">
                            Selecione o início da nova vigência, UF e ICMS
                          </span>
                          <span v-else key="1">
                            {{ itemVO.icms[0] ? itemVO.icms[0].descricao : '' }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="3">
                        <v-menu
                          v-model="menuDataInicio"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              v-model="dataInicioFormatada"
                              v-mask="['##/##/####']"
                              label="Início da nova vigência"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              hide-details
                              @blur="dataInicio = parseDate(dataInicioFormatada)"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker v-model="dataInicio" @input="menuDataInicio = false" />
                        </v-menu>
                      </v-col>
                      <v-col cols="3">
                        <v-autocomplete
                          v-model="icmsUFId"
                          :items="opcoes.uf"
                          :disabled="!dataInicio"
                          label="UF"
                          clearable
                          @change="buscarIcmsDisponiveisPelaUf"
                        />
                      </v-col>
                    </v-row>

                    <v-card elevation="0">
                      <v-text-field
                        v-model="buscaICMS"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                        class="mb-3"
                      />

                      <v-data-table
                        v-model="itemVO.icms"
                        :headers="headersICMS"
                        :items="ICMSs"
                        show-select
                        single-select
                        :loading="buscandoICMSs"
                        :search="buscaICMS"
                        :footer-props="{
                          showFirstLastPage: true,
                          'items-per-page-options': [10, 20, 50]
                        }"
                      >
                      </v-data-table>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row class="mt-5">
              <v-expansion-panels v-model="painelNCM">
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>
                      <v-col cols="2"> NCM * </v-col>
                      <v-col cols="10" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0"> Selecione um NCM </span>
                          <span v-else key="1">
                            {{ itemVO.ncm[0] ? itemVO.ncm[0].descricao : '' }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card elevation="0">
                      <v-text-field
                        v-model="buscaNCM"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                        class="mb-3"
                      />

                      <v-data-table
                        v-model="itemVO.ncm"
                        :headers="headersNCM"
                        :items="NCMs"
                        show-select
                        single-select
                        :loading="buscandoNCMs"
                        :search="buscaNCM"
                        :footer-props="{
                          showFirstLastPage: true,
                          'items-per-page-options': [10, 20, 50]
                        }"
                      >
                      </v-data-table>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row class="mt-5">
              <v-expansion-panels v-model="painelCEST">
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>
                      <v-col cols="2"> CEST </v-col>
                      <v-col cols="10" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0"> Selecione um CEST </span>
                          <span v-else key="1">
                            {{ itemVO.cest[0] ? itemVO.cest[0].descricao : '' }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card elevation="0">
                      <v-row align="center" justify="center">
                        <v-col cols="10">
                          <v-text-field
                            v-model="buscaCEST"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                            class="mb-3"
                          />
                        </v-col>

                        <v-col cols="2" class="text-center">
                          <v-btn
                            color="primary"
                            dark
                            :loading="removendo"
                            @click="removerValorPropriedade('CEST')"
                          >
                            Remover CEST
                          </v-btn>
                        </v-col>

                        <v-col cols="12">
                          <v-data-table
                            v-model="itemVO.cest"
                            :headers="headersCEST"
                            :items="CESTs"
                            show-select
                            single-select
                            :loading="buscandoCESTs"
                            :search="buscaCEST"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-options': [10, 20, 50]
                            }"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row class="mt-5">
              <v-expansion-panels v-model="painelNESH">
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>
                      <v-col cols="2"> NESH </v-col>
                      <v-col cols="10" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0"> Selecione um NESH </span>
                          <span v-else key="1">
                            {{ itemVO.nesh[0] ? itemVO.nesh[0].descricao : '' }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card elevation="0">
                      <v-row align="center" justify="center">
                        <v-col cols="10">
                          <v-text-field
                            v-model="buscaNESH"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                            class="mb-3"
                          />
                        </v-col>

                        <v-col cols="2" class="text-center">
                          <v-btn
                            color="primary"
                            dark
                            :loading="removendo"
                            @click="removerValorPropriedade('NESH')"
                          >
                            Remover NESH
                          </v-btn>
                        </v-col>

                        <v-col cols="12">
                          <v-data-table
                            v-model="itemVO.nesh"
                            :headers="headersNESH"
                            :items="NESHs"
                            show-select
                            single-select
                            :loading="buscandoNESHs"
                            :search="buscaNESH"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-options': [10, 20, 50]
                            }"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row class="mt-5">
              <v-expansion-panels v-model="painelIPI">
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>
                      <v-col cols="2"> IPI </v-col>
                      <v-col cols="10" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0"> Selecione um IPI </span>
                          <span v-else key="1">
                            {{ itemVO.ipi[0] ? itemVO.ipi[0].descricao : '' }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card elevation="0">
                      <v-row align="center" justify="center">
                        <v-col cols="10">
                          <v-text-field
                            v-model="buscaIPI"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                            class="mb-3"
                          />
                        </v-col>

                        <v-col cols="2" class="text-center">
                          <v-btn
                            color="primary"
                            dark
                            :loading="removendo"
                            @click="removerValorPropriedade('IPI')"
                          >
                            Remover IPI
                          </v-btn>
                        </v-col>

                        <v-col cols="12">
                          <v-data-table
                            v-model="itemVO.ipi"
                            :headers="headersIPI"
                            :items="IPIs"
                            show-select
                            single-select
                            :loading="buscandoIPIs"
                            :search="buscaIPI"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-options': [10, 20, 50]
                            }"
                          >
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row class="mt-5">
              <v-expansion-panels v-model="painelPISCOFINS">
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>
                      <v-col cols="2"> PIS COFINS </v-col>
                      <v-col cols="10" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0"> Selecione um PIS COFINS </span>
                          <span v-else key="1">
                            {{ itemVO.pisCofins[0] ? itemVO.pisCofins[0].descricao : '' }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card elevation="0">
                      <v-row align="center" justify="center">
                        <v-col cols="10">
                          <v-text-field
                            v-model="buscaPISCOFINS"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                            class="mb-3"
                          />
                        </v-col>

                        <v-col cols="2" class="text-center">
                          <v-btn
                            color="primary"
                            dark
                            :loading="removendo"
                            @click="removerValorPropriedade('PISCOFINS')"
                          >
                            Remover PIS COFINS
                          </v-btn>
                        </v-col>

                        <v-col cols="12">
                          <v-data-table
                            v-model="itemVO.pisCofins"
                            :headers="headersPISCOFINS"
                            :items="PISCOFINSs"
                            show-select
                            single-select
                            :loading="buscandoPISCOFINSs"
                            :search="buscaPISCOFINS"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-options': [10, 20, 50]
                            }"
                          >
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row class="mt-5">
              <v-expansion-panels v-model="painelNatureza">
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>
                      <v-col cols="2"> Natureza </v-col>
                      <v-col cols="10" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <span v-if="open" key="0"> Selecione uma natureza </span>
                          <span v-else key="1">
                            {{ itemVO.natureza[0] ? itemVO.natureza[0].descricao : '' }}
                          </span>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card elevation="0">
                      <v-row align="center" justify="center">
                        <v-col cols="10">
                          <v-text-field
                            v-model="buscaNatureza"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                            class="mb-3"
                          />
                        </v-col>

                        <v-col cols="2" class="text-center">
                          <v-btn
                            color="primary"
                            dark
                            :loading="removendo"
                            @click="removerValorPropriedade('NATUREZA')"
                          >
                            Remover Natureza
                          </v-btn>
                        </v-col>

                        <v-col cols="12">
                          <v-data-table
                            v-model="itemVO.natureza"
                            :headers="headersNatureza"
                            :items="naturezas"
                            show-select
                            single-select
                            :loading="buscandoNaturezas"
                            :search="buscaNatureza"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-options': [10, 20, 50]
                            }"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-checkbox v-model="itemVO.conferidoIcms" label="100% OK ICMS" />
              </v-col>
              <v-col cols="4">
                <v-checkbox v-model="itemVO.conferidoPisCofins" label="100% OK Pis Cofins" />
              </v-col>
              <v-col cols="4">
                <v-checkbox v-model="itemVO.conferidoFornecedor" label="100% OK Fornecedor" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-alert v-if="showMessageError" dense outlined type="error">
                  {{ dataError }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />
  </v-dialog>
</template>

<script>
import ItensVOService from '@/services/itensVO/itensVO'
import ICMSService from '@/services/icms/icms'
import CESTService from '@/services/cest/cest'
import NCMService from '@/services/ncm/ncm'
import NESHService from '@/services/nesh/nesh'
import IPIService from '@/services/ipi/ipi'
import PISCOFINSService from '@/services/pisCofins/pisCofins'
import NaturezaService from '@/services/natureza/natureza'
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'
import { obrigatorio } from '@/shareds/regrasForm'
import { formatDate, parseDate } from '@/shareds/formatacoes'
import { mask } from 'vue-the-mask'

export default {
  components: { SnackbarMessage },

  directives: { mask },

  props: ['showDialog', 'itensSelecionados', 'operacao', 'opcoes', 'ufId'],

  data: () => ({
    dialog: false,
    itemVO: {
      icms: [],
      cest: [],
      ncm: [],
      nesh: [],
      ipi: [],
      pisCofins: [],
      natureza: []
    },

    //ICMS
    headersICMS: [
      { text: 'Descrição', value: 'descricao' },
      { text: 'ICMS Original', value: 'icmsOriginal' },
      { text: 'ICMS Saída', value: 'icmsSaida' },
      { text: 'MVA', value: 'mva' },
      { text: 'Observacao', value: 'observacao' },
      { text: 'UF', value: 'uf.sigla' },
      { text: 'NCM', value: 'ncm.codigo' },
      { text: 'Lei', value: 'lei.codigo' },
      { text: 'CST', value: 'cst.codigo' }
    ],
    ICMSs: [],
    buscandoICMSs: false,
    buscaICMS: '',
    painelICMS: [],

    //NCM
    headersNCM: [
      { text: 'Código', value: 'codigo', width: '10%' },
      { text: 'Descrição', value: 'descricao', width: '70%' },
      { text: 'Início', value: 'dataInicio' },
      { text: 'Fim', value: 'dataFim' }
    ],
    NCMs: [],
    buscandoNCMs: false,
    buscaNCM: '',
    painelNCM: [],

    // CEST
    headersCEST: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao', width: '400' },
      { text: 'Início', value: 'dataInicio' },
      { text: 'Fim', value: 'dataFim' },
      { text: 'Segmento', value: 'segmento.descricao' },
      { text: 'NCM', value: 'ncm.codigo' }
    ],
    CESTs: [],
    buscandoCESTs: false,
    buscaCEST: '',
    painelCEST: [],

    //NESH
    headersNESH: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'NCM', value: 'ncm.codigo' }
    ],
    NESHs: [],
    buscandoNESHs: false,
    buscaNESH: '',
    painelNESH: [],

    //IPI
    headersIPI: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'NCM', value: 'ncm.codigo' }
    ],
    IPIs: [],
    buscandoIPIs: false,
    buscaIPI: '',
    painelIPI: [],

    //PIS COFINS
    headersPISCOFINS: [
      { text: 'NCM', value: 'ncm.codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Observação', value: 'observacao' },
      { text: 'Lei', value: 'lei.nome' },
      { text: 'PIS Entrada', value: 'percentualPISEntrada' },
      { text: 'COFINS Entrada', value: 'percentualCOFINSEntrada' },
      { text: 'CST Entrada', value: 'cstEntrada.codigo' },
      { text: 'Natureza Entrada', value: 'naturezaEntrada.codigo' },
      { text: 'PIS Saída', value: 'percentualPISSaida' },
      { text: 'COFINS Saída', value: 'percentualCOFINSSaida' },
      { text: 'CST Saída', value: 'cstSaida.codigo' },
      { text: 'Natureza Saída', value: 'naturezaSaida.codigo' }
    ],
    PISCOFINSs: [],
    buscandoPISCOFINSs: false,
    buscaPISCOFINS: '',
    painelPISCOFINS: [],

    //Natureza
    headersNatureza: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Entrada / Saída', value: 'tipoMovimento' }
    ],
    naturezas: [],
    buscandoNaturezas: false,
    buscaNatureza: '',
    painelNatureza: [],

    obrigatorio: obrigatorio,
    formatDate: formatDate,
    parseDate: parseDate,
    salvando: false,
    removendo: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    ncm: '',
    icmsUFId: '',
    menuDataInicio: false,
    dataInicio: '',
    dataInicioFormatada: '',
    icmsDisponiveis: [],
    snackbar: new SnackBar()
  }),

  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    },
    dataInicio() {
      this.dataInicioFormatada = this.formatDate(this.dataInicio)
    },

    painelNCM() {
      if (this.painelNCM === 0 && this.NCMs.length === 0) this.buscarNCMs()
    },

    painelCEST() {
      if (this.painelCEST === 0 && this.CESTs.length === 0) this.buscarCESTs()
    },

    painelNESH() {
      if (this.painelNESH === 0 && this.NESHs.length === 0) this.buscarNESHs()
    },

    painelIPI() {
      if (this.painelIPI === 0 && this.IPIs.length === 0) this.buscarIPIs()
    },

    painelPISCOFINS() {
      if (this.painelPISCOFINS === 0 && this.PISCOFINSs.length === 0) this.buscarPISCOFINSs()
    },

    painelNatureza() {
      if (this.painelNatureza === 0 && this.naturezas.length === 0) this.buscarNaturezas()
    }
  },

  methods: {
    initialize() {
      this.dialog = this.showDialog

      this.itemVO = {
        icms: [],
        cest: [],
        ncm: [],
        nesh: [],
        ipi: [],
        pisCofins: [],
        natureza: []
      }
    },

    async removerValorPropriedade(propriedade) {
      this.removendo = true

      try {
        for (const itemVoId of this.itensSelecionados) {
          await ItensVOService.removerValorPropriedade(itemVoId, propriedade)
        }

        this.snackbar.snackTextParam = 'Valor removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.removendo = false
      }
    },

    async salvar() {
      this.salvando = true
      this.showMessageError = false

      if (this.operacao === 'adicionar' && this.itemVO.ncm.length === 0) {
        this.snackbar.snackTextParam = 'Necessário informar o NCM.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
        return
      }

      const itemVoData = {
        descricao: this.itemVO.descricao,
        codigoBarra: this.itemVO.codigoBarra || undefined,
        cest: this.itemVO.cest[0] || undefined,
        ncm: this.itemVO.ncm[0] || undefined,
        nesh: this.itemVO.nesh[0] || undefined,
        ipi: this.itemVO.ipi[0] || undefined,
        pisCofins: this.itemVO.pisCofins[0] || undefined,
        natureza: this.itemVO.natureza[0] || undefined,
        icmsId: this.itemVO.icms[0]?.id || undefined,
        dataInicioVigencia: this.dataInicio || undefined,
        conferidoIcms: this.itemVO.conferidoIcms || undefined,
        conferidoPisCofins: this.itemVO.conferidoPisCofins || undefined,
        conferidoFornecedor: this.itemVO.conferidoFornecedor || undefined
      }

      try {
        if (this.operacao === 'adicionar') {
          const itemVOSalvo = await ItensVOService.create(itemVoData)

          this.$emit('confirmado', itemVOSalvo)
        } else {
          const itensVOSalvos = await ItensVOService.multiUpdate({
            ...itemVoData,
            ids: this.itensSelecionados
          })

          this.$emit('confirmado', itensVOSalvos)
        }

        this.fecharDialog()
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    buscarIcmsDisponiveisPelaUf() {
      this.buscandoICMSs = true

      ICMSService.getAll({ ufId: this.icmsUFId })
        .then((response) => (this.ICMSs = response))
        .finally(() => (this.buscandoICMSs = false))
    },

    fecharDialog() {
      this.$refs.formDialog.resetValidation()

      this.icmsUFId = ''
      this.dataInicio = ''

      this.NCMs = []
      this.CESTs = []
      this.NESHs = []
      this.IPIs = []
      this.ICMSs = []

      this.painelICMS = []
      this.painelNCM = []
      this.painelCEST = []
      this.painelNESH = []
      this.painelIPI = []
      this.painelPISCOFINS = []
      this.painelNatureza = []

      this.$emit('update:showDialog', false)
      this.dialog = false
    },

    buscarCESTs() {
      this.buscandoCESTs = true

      CESTService.getAll()
        .then((response) => (this.CESTs = response))
        .finally(() => (this.buscandoCESTs = false))
    },

    buscarNCMs() {
      this.buscandoNCMs = true

      NCMService.getAll()
        .then((response) => (this.NCMs = response))
        .finally(() => {
          this.buscandoNCMs = false
        })
    },

    async buscarNESHs() {
      this.buscandoNESHs = true

      NESHService.getAll()
        .then((response) => (this.NESHs = response))
        .finally(() => (this.buscandoNESHs = false))
    },

    buscarIPIs() {
      this.buscandoIPIs = true

      IPIService.getAll()
        .then((response) => (this.IPIs = response))
        .finally(() => (this.buscandoIPIs = false))
    },

    buscarPISCOFINSs() {
      this.buscandoPISCOFINSs = true

      PISCOFINSService.getAll()
        .then((response) => (this.PISCOFINSs = response))
        .finally(() => (this.buscandoPISCOFINSs = false))
    },

    buscarNaturezas() {
      this.buscandoNaturezas = true

      NaturezaService.buscarTodas()
        .then((response) => (this.naturezas = response))
        .finally(() => (this.buscandoNaturezas = false))
    }
  }
}
</script>
